import {
  Component,
  ComponentInterface,
  h,
  Prop,
} from '@stencil/core';

/**
 * @slot unnamed - Slot for paf-result-legend-items
 */

@Component({
  shadow: true,
  styleUrl: 'paf-result-legend.scss',
  tag: 'paf-result-legend',
})

export class PafResultLegend implements ComponentInterface {

  /** The title text for the legend */
  @Prop() public titleText!: string;

  /** The title level for the legend */
  @Prop() public titleLevel!: number;

  /** First text to show as footnote */
  @Prop() public firstFootnote?: string;

  /** Second text to show as footnote */
  @Prop() public secondFootnote?: string;

  public render(): HTMLDivElement {
    const TITLE_TAG = `h${this.titleLevel}`;

    return (
      <div class='legend'>
        <TITLE_TAG
          class='title'
          id='legend-title'
        >
          {this.titleText}
        </TITLE_TAG>

        <ul
          aria-labelledby='legend-title'
          class='list'
        >
          <slot />
        </ul>

        {this.firstFootnote &&
          <p
            class='info'
            innerHTML={this.firstFootnote}
          />
        }

        {this.secondFootnote &&
          <p
            class='info'
            innerHTML={this.secondFootnote}
          />
        }
      </div>
    );
  }
}
